import { once } from 'lodash';

// NOTE: Given how 'once' works, it ignore arguments to de-dupe future calls, so we'll end up using the
// very first instance of ensureGoogle(key) that gets called with that key, and ignore any subsequent
// load calls with a different key if they get loaded in the same context (they will all share the same
// google instance). This is because google api only likes having a single instance of it loaded on the page.

// Google API calls use this project for billing and API keys:
// https://console.cloud.google.com/apis/credentials?project=val-tool-3-1495755979574&organizationId=727186813944

const ensureGoogle = once(
  (googleMapsApiKey: string): Promise<unknown> =>
    new Promise<void>((resolve) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((window as any).google && (window as any).google.maps) {
        resolve();
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).onGoogleMapsLoad = () => {
        resolve();
      };
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&v=3.exp&libraries=geometry,drawing,places&callback=onGoogleMapsLoad`;
      document.getElementsByTagName('head')[0].appendChild(script);
    }),
);

export default ensureGoogle;
